var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "url(#a)",
          d:
            "M0 2.4A2.4 2.4 0 0 1 2.4 0h19.2A2.4 2.4 0 0 1 24 2.4v19.2a2.4 2.4 0 0 1-2.4 2.4H2.4A2.4 2.4 0 0 1 0 21.6V2.4Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#fff",
          "fill-rule": "evenodd",
          d:
            "M18.117 5.999a3.004 3.004 0 0 0-4.255 0L13.86 6l-7.756 7.824a3.853 3.853 0 0 0-1.076 2.172l-.254 1.793c-.141.998.706 1.852 1.695 1.71l1.777-.256a3.794 3.794 0 0 0 2.153-1.086l7.756-7.825.001-.001a3.07 3.07 0 0 0 0-4.294l-.02-.019L18.119 6 18.117 6ZM9.368 17.118l6.376-6.432-2.234-2.253-6.375 6.432c-.36.362-.593.833-.664 1.34l-.254 1.793a.04.04 0 0 0 .046.046l1.777-.256c.503-.072.969-.308 1.328-.67Zm8.01 1.306.306-.942a.445.445 0 0 1 .283-.285l.933-.31c.344-.113.344-.605 0-.719l-.933-.309a.445.445 0 0 1-.283-.285l-.306-.942a.374.374 0 0 0-.714 0l-.306.942a.445.445 0 0 1-.283.285l-.933.31c-.345.113-.345.605 0 .719l.933.309c.134.044.24.15.283.285l.306.942c.113.347.6.347.714 0ZM7.704 9.415l.306-.941a.445.445 0 0 1 .283-.286l.934-.309c.344-.114.344-.605 0-.72l-.934-.308a.445.445 0 0 1-.283-.286l-.306-.941a.374.374 0 0 0-.713 0l-.306.941a.445.445 0 0 1-.283.286l-.933.309c-.345.114-.345.605 0 .72l.933.308c.134.045.239.15.283.286l.306.941c.113.348.6.348.713 0Zm9.418-.12a1.59 1.59 0 0 0 0-2.22l-.001-.002-.015-.015-.015-.014v-.001a1.556 1.556 0 0 0-2.203 0l-.347.35 2.233 2.253.347-.35Z",
          "clip-rule": "evenodd"
        }
      }),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "a",
                x1: "24",
                x2: "0",
                y1: "24",
                y2: "0",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", {
                attrs: { offset: ".022", "stop-color": "#DEA5FA" }
              }),
              _c("stop", { attrs: { offset: ".97", "stop-color": "#733FE0" } })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }